import { render, staticRenderFns } from "./OrderTmsModal.vue?vue&type=template&id=a9214eaa&scoped=true&"
import script from "./OrderTmsModal.vue?vue&type=script&lang=js&"
export * from "./OrderTmsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9214eaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9214eaa')) {
      api.createRecord('a9214eaa', component.options)
    } else {
      api.reload('a9214eaa', component.options)
    }
    module.hot.accept("./OrderTmsModal.vue?vue&type=template&id=a9214eaa&scoped=true&", function () {
      api.rerender('a9214eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/modules/OrderTmsModal.vue"
export default component.exports